import React from "react";
import getClassNameFactory from "../../utilities/classNames";

var SemanticMain = function SemanticMain(_ref) {
  var children = _ref.children,
      role = _ref.role;
  var getClassName = getClassNameFactory(SemanticMain.displayName);
  return /*#__PURE__*/React.createElement("main", {
    "aria-label": "main",
    className: getClassName(),
    role: role
  }, children);
};

SemanticMain.displayName = "SemanticMain";
SemanticMain.defaultProps = {
  role: "main"
};
export default SemanticMain;